import {
  laptopMax,
  mobileXXLargeMax,
  laptopMediumMax,
  mobileXXLargeMin,
} from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';
import GridContainer from '../property/PropertyGrid.style';

export const Container = styled.section<{ maxLength: number }>`
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  margin: 50px auto 0;
  padding: 0 30px 60px;

  @media (${mobileXXLargeMin}) {
    ${GridContainer} {
      padding: 30px 0;
    }
  }

  @media (${laptopMediumMax}) {
    padding: 0 15px 30px;
  }

  @media (${mobileXXLargeMax}) {
    margin-top: 30px;
    padding: 0 0 60px;

    ${GridContainer} {
      padding: 5px 0;
    }
  }

  ${(props) =>
    props.maxLength === 3 &&
    `
    @media (${laptopMax}) {
      li:last-child {
        display: none;
      }
    }
  `}
`;

export const Title = styled.h2`
  color: ${(props) => props.theme.textDark};
  font-size: 36px;
  margin-bottom: 30px;

  @media (${mobileXXLargeMax}) {
    font-size: 26px;
    padding: 0 15px;
  }
`;

export const PopularPropertiesLink = styled(Link)`
  color: ${(props) => props.theme.primary};
  font-weight: bold;
  display: flex;
  width: 100%;

  @media screen and (${mobileXXLargeMax}) {
    padding: 0 15px;
  }

  &:hover {
    color: ${(props) => props.theme.backgroundLight};
  }
`;

export const Arrow = styled.div`
  margin-left: 6px;
`;
